import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import Icon from '../icon';
import { iconsList } from '../icon/glyphs';
import Tooltip from '../tooltip/index';

function Breadcrumbs({
  captions,
  className = null,
  active = false,
  onClick = null,
  icon = null,
  translate = null,
}) {
  const isMobile = bowser.mobile || bowser.tablet;
  const breadcrumbsClass = classNames('ws-breadcrumbs', className, {
    'ws-breadcrumbs--active': active,
    'ws-breadcrumbs--mobile': isMobile,
    'ws-breadcrumbs--with-icon': icon,
    'ws-breadcrumbs--inactive': !onClick,
  });

  return (
    <ul className={breadcrumbsClass} onClick={onClick} {...(translate && { translate })}>
      <li className="ws-breadcrumbs__crumb">{captions.pages}</li>
      <li className="ws-breadcrumbs__crumb">{captions.pageName}</li>
      {icon && (
        <React.Fragment>
          <Icon
            className="ws-breadcrumbs__icon"
            glyph={icon.type}
            onClick={icon.action}
            data-place="bottom"
            data-tip={icon.title}
          />
          {!isMobile && <Tooltip />}
        </React.Fragment>
      )}
    </ul>
  );
}

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  captions: PropTypes.shape({
    pages: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.shape({
    type: PropTypes.oneOf(iconsList),
    action: PropTypes.func,
    title: PropTypes.string,
  }),
  translate: PropTypes.oneOf(['no', 'yes']),
};

export default Breadcrumbs;
